<template>
    <DashboardContainer>
        <ecl/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import ecl from '../components/marketing/EditCampaignList'

export default {
    name: 'editEmailCampaignsList',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        ecl,
    }
};
</script>